export enum EAuditFiltersForm {
  Object = 'object',
  ObjectId = 'object_id',
}

export enum EAuditColumnKeys {
  ID = 'request_id',
  Status = 'request_status',
  ApiHost = 'api_host',
  URL = 'path',
  Who = 'subject_name',
  Action = 'action',
  Fields = 'fields',
  Timestamp = 'timestamp',
}
